import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import UpdatePrompt from "@/components/UpdatePrompt";
import { Loader } from "@/components/common";

import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import DropsFeed from "@/pages/DropsFeed";
import DropDetail from "@/pages/DropDetail";
import LiveDraw from "@/pages/LiveDraw";
import Verify from "@/pages/Verify";
import Shop from "@/pages/Shop";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Wallet from "@/pages/Wallet";
import Orders from "@/pages/Orders";
import Tickets from "@/pages/Tickets";
import Account from "@/pages/Account";
import HostDashboard from "@/pages/HostDashboard";
import Chat from "@/pages/Chat";
import Messages from "@/pages/Messages";
import Legal from "@/pages/Legal";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/drops" element={<Protected><DropsFeed /></Protected>} />
        <Route path="/drops/:id" element={<Protected><DropDetail /></Protected>} />
        <Route path="/drops/:id/draw" element={<Protected><LiveDraw /></Protected>} />
        <Route path="/verify/:id" element={<Verify />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/terms" element={<Legal kind="terms" />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
        <Route path="/orders" element={<Protected><Orders /></Protected>} />
        <Route path="/tickets" element={<Protected><Tickets /></Protected>} />
        <Route path="/account" element={<Protected><Account /></Protected>} />
        <Route path="/chat" element={<Protected><Chat /></Protected>} />
        <Route path="/messages" element={<Protected><Messages /></Protected>} />
        <Route path="/messages/:id" element={<Protected><Messages /></Protected>} />
        <Route path="/host" element={<Protected admin><HostDashboard /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#171a22", border: "1px solid rgba(230,184,74,0.3)", color: "#f7f8fa" } }} />
          <UpdatePrompt />
          <AppRoutes />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
